import { Component, computed, input } from '@angular/core';
import { RaIconComponent } from 'src/app/shared/components/ra-icon/ra-icon.component';
import { TestIdDirective } from 'src/app/shared/directives';

/** Cor do card por tipo de documento (mesma convenção do `iconColorByDocumentType`). */
export type DocumentItemColor = 'blue' | 'green' | 'orange' | 'neutral';

@Component({
    selector: 'document-item',
    templateUrl: 'document-item.component.html',
    styleUrl: 'document-item.component.scss',
    imports: [TestIdDirective, RaIconComponent],
})
export class DocumentItemComponent {
    public id = input<string>('');
    public icon = input<string>('');
    public title = input<string>('');
    public description = input<string>('');
    public color = input<DocumentItemColor>('blue');

    /** Card desabilitado (ex.: opção "em breve"). */
    public disabled = input<boolean>(false);

    /** Texto do selo à direita (ex.: "Em breve"). Quando vazio, exibe a seta. */
    public badge = input<string>('');

    /** Cor forte do ícone conforme o tipo. */
    protected readonly iconColor = computed(() => {
        switch (this.color()) {
            case 'green':
                return 'accentGreen';
            case 'orange':
                return 'accentOrange';
            case 'neutral':
                return 'contentSecondary';
            default:
                return 'accentBlue';
        }
    });
}
